import { GenericCatalogModel } from "../app/models/generic-catalog.model";

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiRoot: 'https://fpc.itimpact.com/',
  accountAPIRoot: 'https://fpc.itimpact.com/api/account'
};

export const TWILIO_ACCOUNT_SID = 'AC2a31060f82a8ec5d8b90f7700b11948b';
export const TWILIO_AUTH_TOKEN = 'dd9fd7cd2939dc8adefb6923abb23d38';
export const PHONE_NUMBER_REGEX = /^\+[1-9]\d{1,14}$/;

export const encode_utf8 = (s) => {
  return unescape(encodeURIComponent(s));
}

export const decode_utf8 = (s) => {
  return decodeURIComponent(escape(s));
}

export const encode_base64 = (s) => {
  return btoa(s);
}

export const decode_64 = (s) => {
  return atob(s);
}

export const LETTER_PROC = [
  'R', 'D', 'T', 'F', 'W', 'C', 'S', 'P', 'Q'
];

export const SEND_TO = [
  { to: 'Everyone', code: -100 },
  { to: 'All Doctors', code: -200 },
  { to: 'All Techs', code: -300 },
  { to: 'All Recpts.', code: -400 },
]

export const NOTE_TYPES = [
  { type: 'Medical', code: 2, selected: true },
  { type: 'Discharge', code: 7, selected: false },
  { type: 'Hospital', code: 1, selected: false },
  { type: 'Reception', code: 8, selected: false },
  { type: 'Vital Signs', code: 0, selected: false },
  { type: 'Other', code: 3, selected: false },
]

export const INVENT = 1;
export const NOMED = 1;
export const H_CHECK = 9;
export const R_CHECK = 10;
export const PAGE_SIZE = 10;

export const BODY_TYME: GenericCatalogModel[] = [
  new GenericCatalogModel('Emaciated'),
  new GenericCatalogModel('Cachexia'),
  new GenericCatalogModel('Thin'),
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Fat (<15%)'),
  new GenericCatalogModel('Obese (>15%)'),
]

export const LIVING_ENVIROMENT: GenericCatalogModel[] = [
  new GenericCatalogModel('Back Yard/Dog House'),
  new GenericCatalogModel('Back Yard/Some Inside'),
  new GenericCatalogModel('Ferral'),
  new GenericCatalogModel('Inside Only'),
  new GenericCatalogModel('Inside w/Exercise Outside'),
  new GenericCatalogModel('Inside/Back Yard'),
  new GenericCatalogModel('Kennel (In & Out)'),
  new GenericCatalogModel('Kennel (In Only)'),
]

export const LIFESTYLE: GenericCatalogModel[] = [
  new GenericCatalogModel('Companion Only'),
  new GenericCatalogModel('Companion/Hunting'),
  new GenericCatalogModel('Companion/Light Protect'),
  new GenericCatalogModel('Companion/Protection'),
  new GenericCatalogModel('Companion/Show'),
  new GenericCatalogModel('Companion/Working'),
  new GenericCatalogModel('Hunting'),
  new GenericCatalogModel('Protection'),
  new GenericCatalogModel('Working'),
  new GenericCatalogModel('Show, Conformation'),
  new GenericCatalogModel('Show, Obedience'),
  new GenericCatalogModel('Show, Field'),
  new GenericCatalogModel('Show, Shitzhund'),
]

export const TEMPERAMENT: GenericCatalogModel[] = [
  new GenericCatalogModel('Dominant'),
  new GenericCatalogModel('Aggressive'),
  new GenericCatalogModel('Passive'),
  new GenericCatalogModel('Timid'),
  new GenericCatalogModel('Outgoing'),
  new GenericCatalogModel('Fearful'),
  new GenericCatalogModel('Hyperactive'),
  new GenericCatalogModel('Calm'),
]

export const HOUSEHOLD_POPULATION: GenericCatalogModel[] = [
  new GenericCatalogModel('Single Adult'),
  new GenericCatalogModel('Adults Only'),
  new GenericCatalogModel('Adults, Kid <5 yrs'),
  new GenericCatalogModel('Adults, Kid 5-10 yrs'),
  new GenericCatalogModel('Adults, Kid >10yrs'),
]

export const OTHER_PETS: GenericCatalogModel[] = [
  new GenericCatalogModel('Amphibians'),
  new GenericCatalogModel('Birds'),
  new GenericCatalogModel('Cat(s)'),
  new GenericCatalogModel('Dog(s)'),
  new GenericCatalogModel('Fish'),
  new GenericCatalogModel('Reptiles'),
  new GenericCatalogModel('Rodents'),
]

export const COAT_CONDITION: GenericCatalogModel[] = [
  new GenericCatalogModel('Alopecia'),
  new GenericCatalogModel('Groomed/Breed Style'),
  new GenericCatalogModel('Groomed/Maintenance'),
  new GenericCatalogModel('Groomed/Short'),
  new GenericCatalogModel('Matting'),
  new GenericCatalogModel('Erythemia'),
  new GenericCatalogModel('Macules'),
  new GenericCatalogModel('Patch'),
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Thinning'),
  new GenericCatalogModel('Hypopigmentation'),
  new GenericCatalogModel('Hyperpigmentation'),
  new GenericCatalogModel('Wheals'),
  new GenericCatalogModel('Urticaria'),
  new GenericCatalogModel('Papule'),
  new GenericCatalogModel('Pustules'),
  new GenericCatalogModel('Laceration'),
  new GenericCatalogModel('Abscess'),
  new GenericCatalogModel('Tumor'),
]

export const MENTAL_CONDITION: GenericCatalogModel[] = [
  new GenericCatalogModel('Alert'),
  new GenericCatalogModel('Comatose'),
  new GenericCatalogModel('Depressed'),
  new GenericCatalogModel('Demented'),
  new GenericCatalogModel('Disorientated'),
  new GenericCatalogModel('Hyperactive'),
  new GenericCatalogModel('Stuporous'),
]

export const TYPE_EXERCISE: GenericCatalogModel[] = [
  new GenericCatalogModel('Free Play'),
  new GenericCatalogModel('On-Leash'),
  new GenericCatalogModel('Structured'),
]

export const FRECUENCY_EXERCISE: GenericCatalogModel[] = [
  new GenericCatalogModel('Free Choice'),
  new GenericCatalogModel('Once a day'),
  new GenericCatalogModel('Twice a day'),
  new GenericCatalogModel('Alternate days'),
  new GenericCatalogModel('1-2/Week'),
  new GenericCatalogModel('Less'),
]

export const DURATION_EXERCISE: GenericCatalogModel[] = [
  new GenericCatalogModel('Unrestricted'),
  new GenericCatalogModel('< 15 min'),
  new GenericCatalogModel('15 min - 30 min'),
  new GenericCatalogModel('30 min - 1 hr'),
  new GenericCatalogModel('> 1 hr but restricted'),
]

export const ECO_PARASITES: GenericCatalogModel[] = [
  new GenericCatalogModel('Demodex , Generalized'),
  new GenericCatalogModel('Demodex , Localized'),
  new GenericCatalogModel('Earmites'),
  new GenericCatalogModel('Fleas , Heavy'),
  new GenericCatalogModel('Fleas , Light'),
  new GenericCatalogModel('Fungus , Generalized'),
  new GenericCatalogModel('Fungus , Localized'),
  new GenericCatalogModel('Notedries'),
  new GenericCatalogModel('Sarcops , Generalized'),
  new GenericCatalogModel('Sarcops , Localized'),
  new GenericCatalogModel('Ticks , Heavy'),
  new GenericCatalogModel('Ticks , Light'),
]

export const TRAINING: GenericCatalogModel[] = [
  new GenericCatalogModel('Basic Obedience'),
  new GenericCatalogModel('Hunting'),
  new GenericCatalogModel('Protection'),
  new GenericCatalogModel('Obedience Competition'),
  new GenericCatalogModel('Conformation'),
  new GenericCatalogModel('Shitzhund'),
  new GenericCatalogModel('Police'),
  new GenericCatalogModel('Detection'),
  new GenericCatalogModel('Livestock'),
]

export const TRAINING_PROFICIENCY: GenericCatalogModel[] = [
  new GenericCatalogModel('Basic'),
  new GenericCatalogModel('Competition'),
  new GenericCatalogModel('Champion'),
]

export const CLIMATE: GenericCatalogModel[] = [
  new GenericCatalogModel('Tropical'),
  new GenericCatalogModel('Subtropical'),
  new GenericCatalogModel('Arid'),
  new GenericCatalogModel('Urban'),
  new GenericCatalogModel('Suburban'),
  new GenericCatalogModel('Small Town'),
  new GenericCatalogModel('Rural'),
]

export const FOOD_FREQ: GenericCatalogModel[] = [
  new GenericCatalogModel('Adlibidum'),
  new GenericCatalogModel('Once a day'),
  new GenericCatalogModel('Twice a day'),
  new GenericCatalogModel('Thrice a day'),
]

export const FOOD_CNT: GenericCatalogModel[] = [
  new GenericCatalogModel('CUP'),
  new GenericCatalogModel('CAN'),
]

export const FOOD_ABNORMAL: GenericCatalogModel[] = [
  new GenericCatalogModel('Vomition'),
  new GenericCatalogModel('Regurgitation'),
]

export const FOOD_ACT: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Wolfing'),
  new GenericCatalogModel('Painful'),
  new GenericCatalogModel('Impaired prehension'),
  new GenericCatalogModel('Impaired swallowing'),
]

export const WATER: GenericCatalogModel[] = [
  new GenericCatalogModel('Bottled'),
  new GenericCatalogModel('City'),
  new GenericCatalogModel('Pond'),
  new GenericCatalogModel('River'),
  new GenericCatalogModel('Well'),
]

export const WATER_FREQ: GenericCatalogModel[] = [
  new GenericCatalogModel('Not drinking'),
  new GenericCatalogModel('1 - 2 times daily'),
  new GenericCatalogModel('3 - 4 times daily'),
  new GenericCatalogModel('5 - 6 times daily'),
  new GenericCatalogModel('Polydipsia'),
]

export const WATER_ACT: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Drooling'),
]

export const FECAL: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Diarrhea'),
  new GenericCatalogModel('Firm'),
  new GenericCatalogModel('Fluids'),
  new GenericCatalogModel('Hard'),
  new GenericCatalogModel('Soft'),
  new GenericCatalogModel('Very Dry'),
]

export const FECAL_FREQ: GenericCatalogModel[] = [
  new GenericCatalogModel('Diarrhea'),
  new GenericCatalogModel('Every 2 - 4 hrs'),
  new GenericCatalogModel('1 - 2 times daily'),
  new GenericCatalogModel('2 - 4 times daily'),
  new GenericCatalogModel('Alternate Day'),
  new GenericCatalogModel('Constipation'),
]

export const FECAL_ACT: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Constipation'),
  new GenericCatalogModel('Involuntary'),
  new GenericCatalogModel('Painful'),
  new GenericCatalogModel('Straining'),
  new GenericCatalogModel('Tenesmus'),
]

export const FECAL_ABNORMAL: GenericCatalogModel[] = [
  new GenericCatalogModel('Blood'),
  new GenericCatalogModel('Foreign Body'),
  new GenericCatalogModel('Mucous'),
  new GenericCatalogModel('Plant Material'),
]

export const FECAL_COLOR: GenericCatalogModel[] = [
  new GenericCatalogModel('Brown'),
  new GenericCatalogModel('Dark Brown'),
  new GenericCatalogModel('Green'),
  new GenericCatalogModel('Red'),
  new GenericCatalogModel('Tan'),
  new GenericCatalogModel('Other'),
]

export const FECAL_VOL: GenericCatalogModel[] = [
  new GenericCatalogModel('Scant'),
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Increased'),
]

export const URINE: GenericCatalogModel[] = [
  new GenericCatalogModel('Difficult'),
  new GenericCatalogModel('Dysuria'),
  new GenericCatalogModel('Enuresis'),
  new GenericCatalogModel('Inappropriate Micturation'),
  new GenericCatalogModel('Nocturia'),
  new GenericCatalogModel('Painful'),
  new GenericCatalogModel('Reflex Incontinence'),
  new GenericCatalogModel('Stranguria'),
  new GenericCatalogModel('Tenesmus'),
]

export const URINE_VOL: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Anuria'),
  new GenericCatalogModel('Dribbling'),
  new GenericCatalogModel('Oliguria'),
  new GenericCatalogModel('Polyuria'),
]

export const URINE_COLOR: GenericCatalogModel[] = [
  new GenericCatalogModel('Clear'),
  new GenericCatalogModel('Dark'),
  new GenericCatalogModel('Red'),
  new GenericCatalogModel('Yellow'),
  new GenericCatalogModel('Other'),
]

export const URINE_ABNORMAL: GenericCatalogModel[] = [
  new GenericCatalogModel('Hematuria'),
  new GenericCatalogModel('Crystalluria'),
  new GenericCatalogModel('Proteinuria'),
  new GenericCatalogModel('Pyuria'),
]

export const URINE_FREQ: GenericCatalogModel[] = [
  new GenericCatalogModel('1 - 3 times daily'),
  new GenericCatalogModel('4 - 6 times daily'),
  new GenericCatalogModel('Incontinence'),
  new GenericCatalogModel('Pollakiuria'),
  new GenericCatalogModel('Retention'),
]

export const MONITOR_ANES: GenericCatalogModel[] = [
  new GenericCatalogModel('Halothane'),
  new GenericCatalogModel('Isofluorane'),
  new GenericCatalogModel('Propofol'),
  new GenericCatalogModel('Domitor'),
  new GenericCatalogModel('Ketamine'),
  new GenericCatalogModel('Ketamine/Ace'),
  new GenericCatalogModel('Ketamine/Valium'),
  new GenericCatalogModel('KARAT'),
]

export const MONITOR_FLUIDS: GenericCatalogModel[] = [
  new GenericCatalogModel('Lac.Ringers'),
  new GenericCatalogModel('Saline'),
  new GenericCatalogModel('Ringers w/ 5% Dex'),
]

export const MONITOR_BREATH: GenericCatalogModel[] = [
  new GenericCatalogModel('Unass/Room Air'),
  new GenericCatalogModel('Assist/Room Air'),
  new GenericCatalogModel('Unass/Oxygen'),
  new GenericCatalogModel('Assist/Oxygen'),
]

export const HYDRATION: GenericCatalogModel[] = [
  new GenericCatalogModel('Good'),
  new GenericCatalogModel('Dehydrated'),
]

export const LUNG_SOUNDS: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Decreased'),
  new GenericCatalogModel('Crackles'),
  new GenericCatalogModel('Wheezes'),
]

export const HEARTH_SOUNDS: GenericCatalogModel[] = [
  new GenericCatalogModel('Sinus Rhythm - normal'),
  new GenericCatalogModel('Arrhythmia'),
  new GenericCatalogModel('Bradycardia'),
  new GenericCatalogModel('Tachycardia'),
  new GenericCatalogModel('Grade 1/6 Murmur'),
  new GenericCatalogModel('Grade 2/6 Murmur'),
  new GenericCatalogModel('Grade 3/6 Murmur'),
  new GenericCatalogModel('Grade 4/6 Murmur'),
  new GenericCatalogModel('Grade 5/6 Murmur'),
  new GenericCatalogModel('Grade 6/6 Murmur'),
  new GenericCatalogModel('Decreased'),
]

export const PULSE_QUALITY: GenericCatalogModel[] = [
  new GenericCatalogModel('Normal'),
  new GenericCatalogModel('Weak'),
  new GenericCatalogModel('Bounding'),
]

export const MM_COLOR: GenericCatalogModel[] = [
  new GenericCatalogModel('Red/Injected'),
  new GenericCatalogModel('Pink - normal'),
  new GenericCatalogModel('Pale'),
  new GenericCatalogModel('White'),
]

export const CRT: GenericCatalogModel[] = [
  new GenericCatalogModel('<1 sec'),
  new GenericCatalogModel('1-2 sec'),
  new GenericCatalogModel('2-3 sec'),
  new GenericCatalogModel('>3 sec'),
  new GenericCatalogModel('Pulse Quality'),
  new GenericCatalogModel('Good'),
]

export const SUTURE: GenericCatalogModel[] = [
]

export const SUTURE_OTHER: GenericCatalogModel[] = [
]

export const TOOTH = [
  new GenericCatalogModel(210),
  new GenericCatalogModel(209),
  new GenericCatalogModel(208),
  new GenericCatalogModel(207),
  new GenericCatalogModel(206),
  new GenericCatalogModel(205),
  new GenericCatalogModel(204),
  new GenericCatalogModel(203),
  new GenericCatalogModel(202),
  new GenericCatalogModel(201),
  new GenericCatalogModel(101),
  new GenericCatalogModel(102),
  new GenericCatalogModel(103),
  new GenericCatalogModel(104),
  new GenericCatalogModel(105),
  new GenericCatalogModel(106),
  new GenericCatalogModel(107),
  new GenericCatalogModel(108),
  new GenericCatalogModel(109),
  new GenericCatalogModel(110),
  new GenericCatalogModel(311),
  new GenericCatalogModel(310),
  new GenericCatalogModel(309),
  new GenericCatalogModel(308),
  new GenericCatalogModel(307),
  new GenericCatalogModel(306),
  new GenericCatalogModel(305),
  new GenericCatalogModel(304),
  new GenericCatalogModel(303),
  new GenericCatalogModel(302),
  new GenericCatalogModel(301),
  new GenericCatalogModel(401),
  new GenericCatalogModel(402),
  new GenericCatalogModel(403),
  new GenericCatalogModel(404),
  new GenericCatalogModel(405),
  new GenericCatalogModel(406),
  new GenericCatalogModel(407),
  new GenericCatalogModel(408),
  new GenericCatalogModel(409),
  new GenericCatalogModel(410),
  new GenericCatalogModel(411),
];
